import { RefObject } from 'react'

import { ContextMenuRef } from '@inno-ui/context-menu'
import { IframeAppInstance } from 'shared/types/index'

import { AppRefType } from '../LaunchPad/LaunchPad.types'

interface BaseAppButtonProps {
  app: IframeAppInstance
  onClick?: () => void
  showLabel?: boolean
  iconRefs?: AppRefType
  index: number
  isLocked?: boolean
  isLoading?: boolean
  tourId: string
  onLabelAnimationComplete?: () => void
  size?: 'medium' | 'large'
  variant?: 'light' | 'dark'
  contextMenuRef?: RefObject<ContextMenuRef>
}

type AppButtonType = 'launchpad' | 'topDock'

export interface AppButtonProps extends BaseAppButtonProps {
  buttonType: AppButtonType
}
